var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 21,
    viewBox: "0 0 39 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 37,
    height: 20,
    rx: 5.33,
    fill: "#F7F7F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 37,
    height: 20,
    rx: 5.33,
    stroke: "#D7D8E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_2781)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4861 11.839C25.2176 12.0953 24.7823 12.0953 24.5139 11.839L20.1875 6.97929V6.98067L24.5139 11.839L20.1875 7.70933V15.3125C20.1875 15.6749 19.8797 15.9688 19.5 15.9688C19.1203 15.9688 18.8125 15.6749 18.8125 15.3125L18.8125 7.70933L14.4861 11.839C14.2177 12.0953 13.7823 12.0953 13.5139 11.839C13.2454 11.5828 13.2454 11.1672 13.5139 10.911L19.013 5.66177C19.0133 5.6615 19.0136 5.66123 19.0139 5.66096C19.08 5.59787 19.1562 5.5503 19.2375 5.51828C19.3177 5.48662 19.4056 5.46904 19.4977 5.46875C19.4985 5.46875 19.4992 5.46875 19.5 5.46875C19.5007 5.46875 19.5015 5.46875 19.5022 5.46875C19.5947 5.46903 19.6828 5.48673 19.7633 5.51859C19.7788 5.52472 19.7941 5.5314 19.8092 5.53866C19.8701 5.56793 19.9274 5.6064 19.9788 5.65405C19.9815 5.65659 19.9843 5.65915 19.9869 5.66173M19.9869 5.66173L25.4861 10.911C25.7546 11.1672 25.7546 11.5828 25.4861 11.839",
    fill: "#585971"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_2781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIcon2);
export default __webpack_public_path__ + "static/media/guide-icon-2.40219b128152dd85cca47412959ef1bd.svg";
export { ForwardRef as ReactComponent };